export default {
  methods: {
    displayErrors(err) {
      if (err.response.status === 500) {
        this.$vs.notify({
          color: 'danger',
          title: 'Alert',
          text: `SERVER ERROR`
        });
      }
      if (err.response.status === 422) {
        let errors = err.response.data.errors;
        for (let prop in errors) {
          this.$vs.notify({
            color: 'danger',
            //title: 'Alert',
            text: `${errors[prop]}`
          });
        }
      }
    }
  }
};
